import { GoogleMapComponent } from './google-map.component';

export const GoogleMapModule = angular
  .module('app.directives.google-map', [])
  .component('updGoogleMap', GoogleMapComponent);
